import type { PointNumber, RollResult, TableState } from './types.js';

export type PhaseEvent =
  | 'natural'             // come-out 7 or 11
  | 'craps'               // come-out 2, 3, or 12
  | 'pointEstablished'    // come-out 4/5/6/8/9/10
  | 'pointMade'           // point phase: roll == point
  | 'sevenOut'            // point phase: 7
  | 'inPoint';            // point phase: any other roll

export interface PhaseTransition {
  nextState: TableState;
  event: PhaseEvent;
}

const POINT_NUMBERS = new Set<number>([4, 5, 6, 8, 9, 10]);

const HISTORY_CAP = 100;

export function advancePhase(state: TableState, roll: RollResult): PhaseTransition {
  const history = state.history.length >= HISTORY_CAP
    ? [...state.history.slice(state.history.length - (HISTORY_CAP - 1)), roll]
    : [...state.history, roll];

  if (state.phase === 'COME_OUT') {
    if (roll.total === 7 || roll.total === 11) {
      return { nextState: { ...state, history }, event: 'natural' };
    }
    if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
      return { nextState: { ...state, history }, event: 'craps' };
    }
    if (POINT_NUMBERS.has(roll.total)) {
      return {
        nextState: { ...state, phase: 'POINT', point: roll.total as PointNumber, history },
        event: 'pointEstablished',
      };
    }
    throw new Error(`unexpected total ${roll.total}`);
  }

  // POINT phase
  if (roll.total === state.point) {
    const { point: _p, ...rest } = state;
    return {
      nextState: { ...rest, phase: 'COME_OUT', history },
      event: 'pointMade',
    };
  }
  if (roll.total === 7) {
    const { point: _p, ...rest } = state;
    return {
      nextState: { ...rest, phase: 'COME_OUT', history },
      event: 'sevenOut',
    };
  }
  return { nextState: { ...state, history }, event: 'inPoint' };
}
